import React from 'react'
import propTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { authenticationService } from '../../Utilities/authenticationService'
import { PATHS } from '../../constants'

export const canAccessAdminSettings = user => Boolean(user?.is_admin || user?.company_admin)

const AdminRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            const currentUser = authenticationService.currentUserValue
            if (!canAccessAdminSettings(currentUser)) {
                return <Redirect to={PATHS.home} />
            }
            return <Component {...props} />
        }}
    />
)

AdminRoute.propTypes = {
    component: propTypes.elementType.isRequired
}

export default AdminRoute
